
import { Component, Vue, Prop } from "vue-property-decorator";
import ClosedPeriod from "../../../domain/restaurant/ClosedPeriod";
import { VuetifyForm } from "@/plugins/vuetify";
import RemoteServices from "@/services/RemoteServices";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import DialogBanner from "@/components/app/DialogBanner.vue";
import Restaurant from "@/domain/restaurant/Restaurant";
@Component({
  components: { DialogBanner, ConfirmationDialog }
})
export default class HolidayDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({
    default: function() {
      return new ClosedPeriod();
    }
  })
  holiday!: ClosedPeriod;

  holidayCopy = ClosedPeriod.copy(this.holiday);

  startDatePicker = false;
  endDatePicker = false;

  formValid = false;

  required = [(v: string) => !!v || "Required"];

  @Prop({ default: null })
  restaurant!: Restaurant | null;

  showStartDatePicker() {
    this.startDatePicker = true;
  }

  showEndDatePicker() {
    this.endDatePicker = true;
  }

  getBannerTitle() {
    if (this.newHoliday) {
      return this.$t("holiday.create.message");
    }
    return this.$t("holiday.edit.message");
  }

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  get newHoliday() {
    return this.holiday.closedPeriodId == null;
  }

  get dialog() {
    return this.value;
  }

  set dialog(newValue) {
    this.$emit("input", newValue);
    if (!newValue) {
      this.holidayCopy = ClosedPeriod.copy(this.holiday);
      this.form.resetValidation();
    }
  }

  get form() {
    return this.$refs.holidayForm as VuetifyForm;
  }

  get startDate() {
    if (
      this.holidayCopy.startDate == null ||
      this.holidayCopy.startDate === ""
    ) {
      return new Date().toISOString();
    }
    return this.holidayCopy.startDate;
  }

  get endDate() {
    if (this.holidayCopy.endDate == null || this.holidayCopy.endDate === "") {
      return "";
    }
    return this.holidayCopy.endDate;
  }

  get hasChanged() {
    return ClosedPeriod.haveDifferences(this.holiday, this.holidayCopy);
  }

  closeAndResetDialog() {
    this.dialog = false;
    ClosedPeriod.updateClosedPeriod(this.holidayCopy, this.holiday);
  }

  async submitChanges() {
    await this.form.validate();
    if (this.formValid) {
      this.$store.dispatch("loading");
      try {
        this.holidayCopy.restaurantId = await this.$store.getters
          .getSelectedRestaurant.restaurantId;
        this.holidayCopy = await RemoteServices.updateHoliday(
          this.holidayCopy,
          this.holidayCopy.restaurantId!
        );
        this.updateHoliday();
        this.$store.dispatch("success", this.$t("holiday.edit.success"));
        this.dialog = false;
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  updateHoliday() {
    ClosedPeriod.updateClosedPeriod(this.holiday, this.holidayCopy);
  }

  addHoliday() {
    this.$emit("new-closed-period", this.holidayCopy);
  }

  removeHoliday() {
    this.$emit("delete-closed-period", this.holiday);
  }

  async createHoliday() {
    await this.form.validate();
    if (this.formValid) {
      this.$store.dispatch("loading");
      try {
        this.holidayCopy.restaurantId = this.restaurant?.restaurantId;
        this.holidayCopy = await RemoteServices.createHoliday(
          this.holidayCopy,
          this.holidayCopy.restaurantId!
        );
        this.addHoliday();
        this.$store.dispatch("success", this.$t("holiday.create.success"));
        this.dialog = false;
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  async deleteHoliday() {
    if (
      await this.confirmationDialog.open(
        this.$tc("holiday.delete.message"),
        this.$t("delete.confirmation") +
          "\n" +
          this.holiday.holidayName! +
          "\n" +
          this.$t("delete.warning")
      )
    ) {
      try {
        this.$store.dispatch("loading");
        await RemoteServices.deleteHoliday(
          this.holiday.closedPeriodId,
          this.restaurant?.restaurantId!,
          ""
        );
        this.$store.dispatch("success", this.$t("holiday.delete.success"));
        this.dialog = false;
        this.removeHoliday();
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }
}
